<template>
  <div>
    <h2>{{ $t('views.endusers.detail.title') }}</h2>

    <section v-for="section in endUserSections" :key="section.endUserId" class="mb-4">
      <h3>Tenant {{ section.tenantName }}</h3>

      <entity-detail-table
        :entityKey="endUserEntityKey"
        :entityId="section.endUserId"
        @control:input="onInput"
        @control:change="onChange"
        @entity:save="onSave"
      />
    </section>
  </div>
</template>

<script>
import EntityDetailTable from '@/components/entity/DetailTable';
import MixinEntityBase from '@/components/mixins/EntityBase';
import MixinEndUserSections from '@/views/EndUsers/_mixins/endUserSections';

const ENDUSER_ENTITY_KEY = 'endcustomerendusers'

export default {
  name: 'EndUsers.Detail',
  mixins: [MixinEntityBase, MixinEndUserSections],
  components: {
    EntityDetailTable
  },
  computed: {
    endUserEntityKey () {
      return ENDUSER_ENTITY_KEY
    }
  },
  methods: {
    onInput(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onChange(controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onSave(entity) {
      this.$store.dispatch(`${ENDUSER_ENTITY_KEY}/updateEntity`, entity)
    }
  }
}
</script>

<style lang="scss"></style>
